export function stepsAnimation() {
    let $animation = $(".steps-list");

    function scrollLoad() {
        if (window.innerWidth >= 1200) {
            let scrollTop = $(window).scrollTop() + $(window).innerHeight() * 0.8;
            $animation.each(function () {
                let $this = $(this);
                if ($this.offset().top <= scrollTop) {
                    $this.addClass("animated");
                }
            });
        }
    }

    window.addEventListener("scroll", () => {
        scrollLoad();
    });
    window.addEventListener("load", () => {
        scrollLoad();
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/stepsAnimation.js